import React, { useCallback, useState } from 'react'
import debounce from 'lodash.debounce'

import { Select } from '@st-operations/uikit/src/v2'
import { searchAudiences } from '_services/partner-branded-audiences'

import './styles.scss'

const DEBOUNCE_DELAY = 500

const BrandedAudienceSelector = ({ value, onChange = () => null }) => {
  const [options, setOptions] = useState({})
  const [textValue, setTextValue] = useState(null)

  const search = useCallback(
    debounce((query) => {
      const qs = {
        q: query,
        kind: 'taxonomy',
        include_taxonomies: 'ttd-health',
        is_branded: true,
        limit: 10,
      }
      searchAudiences(qs).then((response) => {
        const optionsMap = response.items.map((item) => {
          const label = `${item?.taxonomy?.name} > ${item?.name}`
          return {
            // add query to label to allow Select component to show items when searching for IDs
            label: label.toLowerCase().includes(query.toLowerCase())
              ? label
              : `${label} (${query})`,
            value: item,
          }
        })
        setOptions(optionsMap)
      })
    }, DEBOUNCE_DELAY),
    []
  )

  const onInputChange = useCallback(
    (text, action) => {
      //prevent clearing input search value on blur
      if (action?.action !== 'input-blur' && action?.action !== 'menu-close') {
        setTextValue(text)
        search(text)
      } else if (textValue !== null) {
        onChange(textValue)
      }
    },
    [textValue]
  )

  const onChangeWrapper = (option) => {
    setTextValue(null)
    onChange(option?.value)
  }

  return (
    <div className="branded-audience-selector">
      <Select
        label="Audience"
        onInputChange={onInputChange}
        onChange={onChangeWrapper}
        options={options}
        placeholder="Search for a branded audience"
        inputValue={textValue !== null ? textValue : typeof value === 'string' ? value : ''}
        value={value}
        isClearable
        useReactSelect
      />
    </div>
  )
}

export default BrandedAudienceSelector
